var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showReport)?_c('div',[_c('div',{staticClass:"p-t-20",staticStyle:{"width":"100%","height":"280px"},attrs:{"id":"jobOrderReport1"}})]):_c('div',{staticClass:"default-content"},[_c('p',{staticStyle:{"font-size":"x-large"}},[_vm._v("未发现上刊数据")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }